import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { HeldRoot } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { Box, Button, type SxProps, type Theme, Typography } from '@mui/material';

import { institutionLabel } from './namedRefLabel';

const { picker } = appStrings.modules.coachingDashboard.institutionAdmin;

type OperatorRootPickerProps = Readonly<{
  heldRoots: readonly HeldRoot[];
  onSelect: (institutionId: number) => void;
}>;

export const OperatorRootPicker = ({ heldRoots, onSelect }: OperatorRootPickerProps) => (
  <Box id="dashboard-operator-root-picker" sx={pickerSx} role="group" aria-label={picker.title}>
    <Typography variant="text-lg-semibold">{picker.title}</Typography>
    <Typography variant="text-sm-regular">{picker.body}</Typography>
    <Box sx={optionsSx}>
      {heldRoots.map((root) => (
        <Button
          key={root.id}
          id={`dashboard-operator-root-${root.id}`}
          hierarchy="Secondary gray"
          size="md"
          onClick={() => onSelect(root.id)}
        >
          {institutionLabel(root)}
        </Button>
      ))}
    </Box>
  </Box>
);

const pickerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-lg'],
  padding: backrs.spacing['spacing-3xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
  borderRadius: backrs.radius['radius-xl'],
});

const optionsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-md'],
});
